import { FC } from 'react';
import { ScheduledCall, useGetCurrentUserQuery } from '@teachur/http-client';
import { ActivityStatsCard } from '../ActivityStatsCard/ActivityStatsCard';
import { CalendarAgenda } from '../CalendarAgenda/CalendarAgenda';
import { DegreeAccordion } from '../DegreeAccordion/DegreeAccordion';
import { Hero } from '../Hero/Hero';

interface EnrolledStudentViewProps {
  scheduledCalls: ScheduledCall[];
  selectedDate: Date;
  onDateChange: (date: Date) => void;
  onJoinCall: (videoCallId: string) => void;
}

export const EnrolledStudentView: FC<EnrolledStudentViewProps> = ({
  scheduledCalls,
  selectedDate,
  onDateChange,
  onJoinCall,
}) => {
  const { data: user } = useGetCurrentUserQuery();
  const degrees = (user?.enrolledDegrees ?? []).flatMap(({ id, degree }) =>
    degree ? [{ id, degree }] : []
  );

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-stretch">
        <div className="min-w-0 flex-1">
          <Hero
            title={user?.firstName ? `Welcome back, ${user.firstName}!` : 'Welcome back!'}
            subtitle="Every lesson moves you closer to your degree. Keep building on the work you've already done."
          />
        </div>
        <ActivityStatsCard />
      </div>

      <div className="flex flex-col gap-6 xl:flex-row xl:items-start">
        <div className="flex min-w-0 flex-1 flex-col gap-6">
          {degrees.map(({ id, degree }, index) => (
            <DegreeAccordion key={id} degree={degree} defaultOpen={index === 0} />
          ))}
        </div>
        <div className="flex w-full xl:w-95.5 xl:shrink-0">
          <CalendarAgenda
            scheduledCalls={scheduledCalls}
            selectedDate={selectedDate}
            onDateChange={onDateChange}
            onJoinCall={onJoinCall}
          />
        </div>
      </div>
    </div>
  );
};
